<template>
    <span class="badge" :class="classes">{{ statusText }}</span>
</template>

<script>

  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {string}
       */
      statusText() {
        return _.get(this, 'row.model.status_text');
      },

      /**
       * @return {number|null}
       */
      status() {
        return _.get(this, 'row.model.status');
      },

      /**
       * @return {object}
       */
      classes() {
        const map = {
          1: 'badge-purple',  // DRAFT
          2: 'badge-info',  // PENDING
          3: 'badge-purple',  // SCHEDULING
          4: 'badge-purple',  // SCHEDULED
          5: 'badge-purple',  // SENDING
          6: 'badge-secondary',  // SENT
          7: 'badge-secondary',  // CANCELED
        };

        return  {[_.get(map, this.status, 'badge-secondary')]: true};
      },
    },
  }
</script>

